import styled from 'styled-components';

export const Container = styled.div`
  padding: 1rem;
  width: 100%;
  background: ${({ theme }) => theme.colors.grayIce};
  border-radius: 6px;
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

export const Body = styled.div`
  margin-top: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  overflow-y: auto;
`;
